<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        md="8"
        cols="12"
      >
        <material-card
          :title="'Orders'"
          color="primary"
        >
          <v-data-table
            :loading="loadingOrders"
            :headers="headers"
            :items="orders"
            :items-per-page="10"
          >
            <template v-slot:item.created="props">
              {{ moment(props.item.created).format('DD-MM-YY') }}
            </template>
          </v-data-table>
          <template v-slot:actions>
            <v-spacer />
            <vue-json-to-csv
              v-if="orders && orders.length > 0"
              :json-data="orders"
              :csv-title="'Orders'"
            >
              <v-btn
                color="primary"
              >
                Download
              </v-btn>
            </vue-json-to-csv>
          </template>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import VueJsonToCsv from 'vue-json-to-csv'
  export default {
    components: {
      VueJsonToCsv
    },
    data () {
      return {
        headers: [{
                    text: 'Created',
                    value: 'created',
                    align: 'left'
                  }, {
                    text: 'Email',
                    value: 'email',
                    align: 'left'
                  },
                  {
                    text: 'Amount',
                    value: 'amount',
                    align: 'right'
                  },
                  {
                    text: 'Status',
                    value: 'status',
                    align: 'right'
                  }],
        orders: [],
        loadingOrders: false,
      }
    },
    computed: {
      site: function () {
        return this.$store.state.site
      }
    },
    mounted () {
      this.getOrders()
    },
    methods: {
      moment,
      getOrders () {
        this.loadingOrders = true
        this.api.get('orders/site/' + this.site)
          .then(result => {
            this.orders = result.data
            this.loadingOrders = false
          }, error => {
            this.loadingOrders = false
            this.error = error
          })
      }
    }

  }
</script>
